import { connect } from 'react-redux'
import Search from './Search'
import { closeSearch, searchStompunkt } from '../../actionCreators';

const mapStateToProps = (state, ownProps) => ({});

const mapDispatchToProps = (dispatch, ownProps) => ({
	onClose: () => dispatch(closeSearch()),
	onSearch: () => dispatch(searchStompunkt())
});

export default connect(mapStateToProps, mapDispatchToProps)(Search);


// WEBPACK FOOTER //
// ./src/components/MapMenu/SearchContainer.js